<template>
  <div class="bdt-checkbox">
    <div class="container">
      <label v-if="label" :for="id">
        {{ label }}
        <span v-if="required" class="text-danger">{{ required ? '*' : '' }}</span>
      </label>
      <input
        :name="id"
        :id="id"
        type="checkbox"
        v-model="checked"
        @change="onChange"
        v-bind="$attrs"
      />
    </div>
    <div v-if="error" class="d-block mx-2">
      <small class="text-error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'CheckInput',
  props: {
    id: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: [String, Number, Boolean],
    label: String,
    error: String,
  },
  data() {
    return {
      checked: this.value,
    }
  },
  watch: {
    checked(checked) {
      this.$emit('input', checked)
    },
  },
  methods: {
    onChange() {
      this.$emit('input', this.checked)
      console.log(this.$attrs)
    },
  },
}
</script>

<style lang="scss" scoped></style>
